import { format, parseISO } from 'date-fns';
import { ar, enUS } from 'date-fns/locale';

/**
 * Format date according to locale
 */
export const formatDate = (
  date: string | Date,
  formatString: string = 'PP',
  locale: 'ar' | 'en' = 'ar'
): string => {
  const dateObj = typeof date === 'string' ? parseISO(date) : date;
  const localeObj = locale === 'ar' ? ar : enUS;
  
  return format(dateObj, formatString, { locale: localeObj });
};

/**
 * Format date relative to now (e.g., "2 hours ago")
 */
export const formatRelativeTime = (
  date: string | Date,
  locale: 'ar' | 'en' = 'ar'
): string => {
  const dateObj = typeof date === 'string' ? parseISO(date) : date;
  const now = new Date();
  const diffInSeconds = Math.floor((now.getTime() - dateObj.getTime()) / 1000);

  if (locale === 'ar') {
    if (diffInSeconds < 60) return 'منذ لحظات';
    if (diffInSeconds < 3600)
      return `منذ ${Math.floor(diffInSeconds / 60)} دقيقة`;
    if (diffInSeconds < 86400)
      return `منذ ${Math.floor(diffInSeconds / 3600)} ساعة`;
    if (diffInSeconds < 2592000)
      return `منذ ${Math.floor(diffInSeconds / 86400)} يوم`;
    return formatDate(dateObj, 'PP', 'ar');
  } else {
    if (diffInSeconds < 60) return 'just now';
    if (diffInSeconds < 3600)
      return `${Math.floor(diffInSeconds / 60)} minutes ago`;
    if (diffInSeconds < 86400)
      return `${Math.floor(diffInSeconds / 3600)} hours ago`;
    if (diffInSeconds < 2592000)
      return `${Math.floor(diffInSeconds / 86400)} days ago`;
    return formatDate(dateObj, 'PP', 'en');
  }
};

